module.exports = "<div style=\"text-align: center;\" *ngIf=\"results && results.length <= 0\">\r\n  <br />\r\n  <h5>{{ title }}</h5>\r\n</div><div style=\"text-align: center;\" *ngIf=\"results && results.length <= 0\">\r\n  <br />\r\n  <h5>{{ title }}</h5>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/display/no-result/no-result.component.html
// module id = 1155
// module chunks = 0